var map = {
	"./qsgc-typecont1.png": 4808,
	"./qsgc-typecont2.png": 1667,
	"./qsgc-typecont3.png": 7562,
	"./qsgc-typecont4.png": 7685,
	"./qsgc-typecont5.png": 5420,
	"./qsgc-typecont6.png": 6804
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7066;